import { render, staticRenderFns } from "./product-bullets.vue?vue&type=template&id=63e1251a&"
import script from "./product-bullets.vue?vue&type=script&lang=ts&"
export * from "./product-bullets.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/peter/dev/subscription-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63e1251a')) {
      api.createRecord('63e1251a', component.options)
    } else {
      api.reload('63e1251a', component.options)
    }
    module.hot.accept("./product-bullets.vue?vue&type=template&id=63e1251a&", function () {
      api.rerender('63e1251a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/product-bullets.vue"
export default component.exports